import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { SignedIn, SignedOut, RedirectToSignIn } from "@clerk/clerk-react";
import Sidebar from "@/components/Sidebar";
import Dashboard from "@/pages/Dashboard";
import Platforms from "@/pages/Platforms";
import PlatformDetail from "@/pages/PlatformDetail";
import CountryCompliance from "@/pages/CountryCompliance";
import CountryComparison from "@/pages/CountryComparison";
import Deadlines from "@/pages/Deadlines";
import GapAnalysis from "@/pages/GapAnalysis";
import ComplianceComparison from "@/pages/ComplianceComparison";
import ComplianceModels from "@/pages/ComplianceModels";
import BusinessFlows from "@/pages/BusinessFlows";
import PitchGenerator from "@/pages/PitchGenerator";
import Reports from "@/pages/Reports";
import SignInPage from "@/pages/SignInPage";
import KnowledgeBase from "@/pages/KnowledgeBase";
import Competitors from "@/pages/Competitors";

// Protected route wrapper
const ProtectedRoute = ({ children }) => {
  return (
    <>
      <SignedIn>{children}</SignedIn>
      <SignedOut>
        <RedirectToSignIn />
      </SignedOut>
    </>
  );
};

// Layout with sidebar for authenticated users
const AuthenticatedLayout = ({ children }) => {
  return (
    <div className="app-layout">
      <Sidebar />
      <main className="main-content">
        {children}
      </main>
    </div>
  );
};

function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Public sign-in route */}
        <Route path="/sign-in/*" element={<SignInPage />} />
        
        {/* Protected routes */}
        <Route path="/" element={
          <ProtectedRoute>
            <AuthenticatedLayout>
              <Dashboard />
            </AuthenticatedLayout>
          </ProtectedRoute>
        } />
        <Route path="/platforms" element={
          <ProtectedRoute>
            <AuthenticatedLayout>
              <Platforms />
            </AuthenticatedLayout>
          </ProtectedRoute>
        } />
        <Route path="/platforms/:platformId" element={
          <ProtectedRoute>
            <AuthenticatedLayout>
              <PlatformDetail />
            </AuthenticatedLayout>
          </ProtectedRoute>
        } />
        <Route path="/countries" element={
          <ProtectedRoute>
            <AuthenticatedLayout>
              <CountryCompliance />
            </AuthenticatedLayout>
          </ProtectedRoute>
        } />
        <Route path="/country-comparison" element={
          <ProtectedRoute>
            <AuthenticatedLayout>
              <CountryComparison />
            </AuthenticatedLayout>
          </ProtectedRoute>
        } />
        <Route path="/deadlines" element={
          <ProtectedRoute>
            <AuthenticatedLayout>
              <Deadlines />
            </AuthenticatedLayout>
          </ProtectedRoute>
        } />
        <Route path="/gap-analysis" element={
          <ProtectedRoute>
            <AuthenticatedLayout>
              <GapAnalysis />
            </AuthenticatedLayout>
          </ProtectedRoute>
        } />
        <Route path="/comparison" element={
          <ProtectedRoute>
            <AuthenticatedLayout>
              <ComplianceComparison />
            </AuthenticatedLayout>
          </ProtectedRoute>
        } />
        <Route path="/compliance-models" element={
          <ProtectedRoute>
            <AuthenticatedLayout>
              <ComplianceModels />
            </AuthenticatedLayout>
          </ProtectedRoute>
        } />
        <Route path="/business-flows" element={
          <ProtectedRoute>
            <AuthenticatedLayout>
              <BusinessFlows />
            </AuthenticatedLayout>
          </ProtectedRoute>
        } />
        <Route path="/pitch-generator" element={
          <ProtectedRoute>
            <AuthenticatedLayout>
              <PitchGenerator />
            </AuthenticatedLayout>
          </ProtectedRoute>
        } />
        <Route path="/reports" element={
          <ProtectedRoute>
            <AuthenticatedLayout>
              <Reports />
            </AuthenticatedLayout>
          </ProtectedRoute>
        } />
        <Route path="/knowledge-base" element={
          <ProtectedRoute>
            <AuthenticatedLayout>
              <KnowledgeBase />
            </AuthenticatedLayout>
          </ProtectedRoute>
        } />
        <Route path="/competitors" element={
          <ProtectedRoute>
            <AuthenticatedLayout>
              <Competitors />
            </AuthenticatedLayout>
          </ProtectedRoute>
        } />
        
        {/* Catch-all redirect */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      <Toaster position="top-right" />
    </BrowserRouter>
  );
}

export default App;
